(function() {
  "use strict";

  angular.module("app").factory("LoadingService", [LoadingService]);

  // As noted in http://stackoverflow.com/a/2117523/302749
  function generateTaskId() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
      var r = (Math.random() * 16) | 0,
        v = c == "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  function LoadingService() {
    return {
      taskStart: function(scope, description) {
        var tasks = scope.loadingTasks || [],
          taskId = generateTaskId();

        scope.loadingTasks = tasks.concat({
          id: taskId,
          description: description
        });
        return taskId;
      },
      taskEnd: function(scope, id) {
        var tasks = scope.loadingTasks || [];
        scope.loadingTasks = tasks.filter(function(t) {
          return t.id !== id;
        });
      }
    };
  }
})();
